export function safeParseDate(str) {
	const date = str ? new Date(str) : null;
	if (date && isNaN(date.getDate())) {
		return null;
	}

	return date;
}
